import React, { useState } from 'react';
import { TextField, Box, Button, 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    MenuItem, Select, FormControl, InputLabel,
    FormControlLabel, RadioGroup, Radio,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { de, enGB } from 'date-fns/locale';
import FlexBetween from 'components/FlexBetween';


const CrewFilterDialog = ({
    open,
    onClose,
    onApply,
    postOptions,
    baseOptions,
    trainingQualOptions,
    isActiveOptions,
    currentFilters,
}) => {
    const locales = { 'en-us': undefined, 'en-gb': enGB, de };

    const initialFilterValues = {
        crewCode: '',
        crewName: '',
        post: [],
        base: [],
        trainingQuals: [],
        quals: '',
        isActive: 'ALL',
    };

    const [filterValues, setFilterValues] = useState(() => {
        if (!currentFilters) return initialFilterValues;
        return {
            ...initialFilterValues,
            ...currentFilters,
            post: currentFilters.post ?? [],
            base: currentFilters.base ?? [],
            trainingQuals: currentFilters.trainingQuals ?? [],
        };
    });

    const handleFilterChange = (field) => (event) => {
        const value = event.target.value;
        setFilterValues(prev => ({
            ...prev,
            [field]: value, 
        }));
    }; 

    const handleIsActiveChange = (event) => {
        setFilterValues(prev => ({
            ...prev,
            isActive: event.target.value, 
        }));
    };

    const handleApply = () => {
        const appliedFilters = {
            ...filterValues,
            isActive: filterValues.isActive || 'ALL', 
            base: filterValues.base.length ? filterValues.base : null,
            post: filterValues.post.length ? filterValues.post : null,            
        };
    
        onApply(appliedFilters);
        onClose();
    };
    
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleApply();
        }
    };
    
    const handleCancel = () => {
        setFilterValues(initialFilterValues);  
        onApply(null);
        onClose();  
    };


    return (   
        <LocalizationProvider 
            dateAdapter={AdapterDateFns}
            adapterLocale={locales['en-gb']}
        >     
            <Dialog 
                open={open} 
                onClose={handleCancel}
                sx={{ '& .MuiDialog-paper': { minWidth: '40%' } }}
            >
                <DialogTitle>
                    Filter
                </DialogTitle>
                <DialogContent onKeyDown={handleKeyPress}>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <FlexBetween
                            gap={2}
                            sx={{ marginTop: '6px' }}
                        >         
                            <TextField
                                label="Crew Code"
                                value={filterValues.crewCode}
                                onChange={handleFilterChange('crewCode')}
                            />                   
                            <TextField
                                fullWidth
                                label="Crew Name"
                                value={filterValues.crewName}
                                onChange={handleFilterChange('crewName')}
                            />                            
                        </FlexBetween> 
                                                 
                        <FlexBetween gap={2}> 
                            <FormControl sx={{ width: '50%' }}>
                                <InputLabel>Post</InputLabel>
                                <Select
                                    multiple
                                    label="Post"
                                    value={filterValues.post}
                                    onChange={handleFilterChange('post')}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    {postOptions && postOptions.map((post, index) => (
                                        <MenuItem key={index} value={post}>{post}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>  
                            <FormControl sx={{ width: '50%' }}>
                                <InputLabel>Base</InputLabel>
                                <Select
                                    multiple
                                    label="Base"
                                    value={filterValues.base}
                                    onChange={handleFilterChange('base')}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    {baseOptions && baseOptions.map((base, index) => (
                                        <MenuItem key={index} value={base}>{base}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>                          
                        </FlexBetween>
                        
                        <FlexBetween gap={2}>
                            <TextField
                                fullWidth
                                label="Quals"
                                value={filterValues.quals}
                                sx={{ width: '50%' }}
                                onChange={handleFilterChange('quals')}
                            />                    

                            <FormControl sx={{ width: '50%' }}>
                                <InputLabel>Trainer</InputLabel>
                                <Select
                                    multiple
                                    label="Trainer"
                                    value={filterValues.trainingQuals}
                                    onChange={handleFilterChange('trainingQuals')}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    {trainingQualOptions && trainingQualOptions?.map((trainingQual, index) => (
                                        <MenuItem key={index} value={trainingQual}>{trainingQual}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>        
                        </FlexBetween>  
                        {isActiveOptions && (
                            <Box>                            
                                <RadioGroup
                                    value={filterValues.isActive}
                                    onChange={handleIsActiveChange}
                                    row
                                >
                                    <FormControlLabel value="ALL" control={<Radio />} label="All" />
                                    <FormControlLabel value="ACTIVE" control={<Radio />} label="Active" />
                                    <FormControlLabel value="INACTIVE" control={<Radio />} label="Inactive" />
                                </RadioGroup>
                            </Box>
                        )}                     
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="outlined" 
                        color="secondary"
                        onClick={handleCancel} 
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="outlined"
                        onClick={handleApply} 
                    >
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
};

export default CrewFilterDialog;